import Select from 'src/components/primitives/Select/Select';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import { WithClassName } from 'src/utils/UtilityTypes';

export type OrderStatusFilter = 'all' | 'filled';
type OrderStatusFilterOption = {
	value: OrderStatusFilter;
	label: string;
};

const ORDER_STATUS_OPTIONS: OrderStatusFilterOption[] = [
	{ value: 'all', label: 'All' },
	{ value: 'filled', label: 'Filled' },
];

interface Props extends WithClassName {
	currentFilledOrdersValue: OrderStatusFilter;
	handleTableFilterChange: (selectedFilter: OrderStatusFilter) => void;
}

export default function OrderHistoryOrderStatusFilter({
	className,
	currentFilledOrdersValue,
	handleTableFilterChange,
}: Props) {
	const {
		selectOptions,
		selectedOption,
		value,
		onValueChange,
		open,
		onOpenChange,
	} = useSelect({
		options: ORDER_STATUS_OPTIONS,
		onSelectedValueChange: handleTableFilterChange,
		selectedValue: currentFilledOrdersValue,
	});

	return (
		<Select.Root
			open={open}
			onOpenChange={onOpenChange}
			value={value}
			onValueChange={onValueChange}
		>
			<Select.Trigger label="Status" className={className}>
				{selectedOption?.label ?? 'Select'}
			</Select.Trigger>
			<Select.Options>
				{selectOptions.map((option) => (
					<Select.Option key={option.value} value={option.value}>
						{option.label}
					</Select.Option>
				))}
			</Select.Options>
		</Select.Root>
	);
}
